export const SET_ACCESS_CONFIG = "SET_ACCESS_CONFIG";
export const FLUSH_ACCESS_CONFIG = "FLUSH_ACCESS_CONFIG";
